import { Observable } from 'rxjs';
import { YesOrNoComponent } from './../../../../../dialog/yes-or-no/yes-or-no.component';
import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CashierManagementService } from '../../services/cashier-management.service';
import { FinancialAccountCashierManagement } from '../../models/financial-account-cashier-management.model';
import { FormControl } from '@angular/forms';
import { CashierManagementDeposit } from '../../models/cashier-management-deposit.model';
import { MatTable } from '@angular/material/table';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'kt-cashier-management-deposit',
    templateUrl: './cashier-management-deposit.component.html',
    styleUrls: ['./cashier-management-deposit.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CashierManagementDepositComponent implements OnInit {
    @ViewChild(MatTable) table: MatTable<FinancialAccountCashierManagement>;
    public financialAccounts: Array<FinancialAccountCashierManagement>;

    public dateDeposit: FormControl;
    public valueDeposit: number;
    public financialAccount: FinancialAccountCashierManagement;

    public selectedDeposit: CashierManagementDeposit;
    public dateDepositEdit: FormControl;
    public valueDepositEdit: number;
    public financialAccountEdit: FinancialAccountCashierManagement;

    public displayedColumns: string[] = ['financialAccountId', 'date', 'value', 'actions'];
    public listCashierManagementDeposit: Array<CashierManagementDeposit>;

    constructor(
        public _loaderService: LoaderService,
        public _spinner: NgxSpinnerService,
        public dialogRef: MatDialogRef<CashierManagementDepositComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _dialog: MatDialog,
        private _cashierManagementService: CashierManagementService,
        private _notificationsService: NotificationsService
    ) {
        this.financialAccounts = new Array<FinancialAccountCashierManagement>();
        this.dateDeposit = new FormControl({ value: '', disabled: true });
        this.valueDeposit = 0;
        this.financialAccount = new FinancialAccountCashierManagement();
        this.listCashierManagementDeposit = new Array<CashierManagementDeposit>();
        this.selectedDeposit = null;
        this.dateDepositEdit = new FormControl({ value: '', disabled: true });
        this.valueDepositEdit = 0;
        this.financialAccountEdit = new FinancialAccountCashierManagement();
    }

    ngOnInit(): void {
        if (this.data.cashier.legalEntityId) {
            this.getFinancialAccount(this.data.cashier.legalEntityId);
        }
    }

    private yesOrNoDialog(title: string, text: string): Observable<any> {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = 260;
        dialogConfig.data = {
            title: title,
            text: text,
        };
        const dialogRef = this._dialog.open(YesOrNoComponent, dialogConfig);

        return dialogRef.afterClosed();
    }

    public onCancelDeposit(): void {
        if (this.listCashierManagementDeposit.length > 0) {
            this.yesOrNoDialog('Confirmação de Descarte', 'Tem certeza que deseja descartar depósitos?').subscribe(
                (result) => {
                    if (result) {
                        this.dialogRef.close();
                    }
                }
            );
        } else {
            this.dialogRef.close();
        }
    }

    private getFinancialAccount(legalEntityId: string): void {
        this._cashierManagementService.getFinancialAccount(legalEntityId).subscribe((response) => {
            if (response.success) {
                this.financialAccounts = response.data;
            }
        });
    }

    public isValidNewDeposit(): boolean {
        if (this.dateDeposit.value === '') {
            return false;
        }

        if (this.valueDeposit <= 0) {
            return false;
        }

        if (this.financialAccount.financialAccountId === '') {
            return false;
        }

        return true;
    }

    public isValidEditDeposit(): boolean {
        if (this.dateDepositEdit.value === '') {
            return false;
        }

        if (this.valueDepositEdit <= 0) {
            return false;
        }

        if (this.financialAccountEdit.financialAccountId === '') {
            return false;
        }

        return true;
    }

    public addDeposit(): void {
        if (this.isValidNewDeposit()) {
            if (this.valueToDepositIsValid(this.valueDeposit)) {
                let cashierManagementDeposit = new CashierManagementDeposit();
                cashierManagementDeposit.date = this.dateDeposit.value;
                cashierManagementDeposit.value = this.valueDeposit;
                cashierManagementDeposit.financialAccountId = this.financialAccount.financialAccountId;
                this.listCashierManagementDeposit.push(cashierManagementDeposit);

                this.dateDeposit.setValue('');
                this.valueDeposit = 0;
                this.financialAccount.financialAccountId;
                this.table.renderRows();
            } else {
                this._notificationsService.info('Valor do Depósito não pode ser maior que o Saldo Atual');
            }
        }
    }

    private valueToDepositIsValid(value: number): boolean {
        return !(this.data.cashier?.toDeposit - (value + this.getSumDeposit()) < 0);
    }

    public getFinancialAccountName(financialAccountId: string): string {
        let financialAccount = this.financialAccounts.find((financialAccount) => {
            return financialAccount.financialAccountId === financialAccountId;
        });

        return (
            financialAccount.companyName + ' - ' + financialAccount.branchCode + ' - ' + financialAccount.accountCode
        );
    }

    public onDeleteDeposit(index: number): void {
        this.yesOrNoDialog('Confirmação de Exclusão', 'Tem certeza que deseja excluir depósito selecionado?').subscribe(
            (result) => {
                if (result) {
                    this.removeDeposit(index);
                }
            }
        );
    }

    private removeDeposit(index: number): void {
        this.listCashierManagementDeposit.splice(index, 1);
        this.table.renderRows();
    }

    public onSaveEditDeposit(index: number): void {
        if (this.isValidEditDeposit()) {
            if (this.valueToDepositIsValid(this.valueDepositEdit - this.selectedDeposit.value)) {
                this.listCashierManagementDeposit[index].date = this.dateDepositEdit.value;
                this.listCashierManagementDeposit[index].value = this.valueDepositEdit;
                this.listCashierManagementDeposit[index].financialAccountId =
                    this.financialAccountEdit.financialAccountId;

                this.dateDepositEdit.setValue('');
                this.valueDepositEdit = 0;
                this.table.renderRows();
                this.selectedDeposit = null;
            } else {
                this._notificationsService.info('Valor do Depósito não pode ser maior que o Saldo Atual');
            }
        }
    }

    public onEditDeposit(deposit: CashierManagementDeposit): void {
        this.selectedDeposit = deposit;

        this.financialAccountEdit = this.financialAccounts.find((financialAccount) => {
            return financialAccount.financialAccountId === deposit.financialAccountId;
        });
        this.dateDepositEdit.setValue(deposit.date);
        this.valueDepositEdit = deposit.value;
    }

    public getSumDeposit(): number {
        let sum = 0;
        this.listCashierManagementDeposit.forEach((deposit) => {
            sum += deposit.value;
        });

        return sum;
    }

    public onSaveDeposit(): void {
        if (this.listCashierManagementDeposit.length > 0) {
            this.yesOrNoDialog('Depositar', 'Tem certeza que deseja depósitar?').subscribe((result) => {
                if (result) {
                    this._spinner.show();
                    this._cashierManagementService
                        .depositCash(this.data.cashier.batchId, this.listCashierManagementDeposit)
                        .subscribe((response) => {
                            this._spinner.hide();
                            if (response.success) {
                                this.dialogRef.close(true);
                            }
                        });
                }
            });
        }
    }
}
